var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'pnlm-container-huygens':
    _vm.getAppName() == 'huygens',
  'pnlm-container-dordrecht5D':
    _vm.getAppName() == 'dordrecht5D',
  'pnlm-container-canals5D':
    _vm.getAppName() == 'canals5D'
}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isViewerLoaded),expression:"isViewerLoaded"}],staticClass:"back-button",class:{
    'back-button-huygens':
      _vm.getAppName() == 'huygens',
    'back-button-dordrecht5D':
      _vm.getAppName() == 'dordrecht5D',
    'back-button-canals5D':
      _vm.getAppName() == 'canals5D'
  },on:{"click":function () { return _vm.$router.push({ name: 'map-view' }); }}},[_c('BaseIcon',{attrs:{"icon":"arrow-left"}})],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isViewerLoaded),expression:"isViewerLoaded"}],staticClass:"info-button",class:{
    'info-button-huygens':
      _vm.getAppName() == 'huygens',
    'info-button-dordrecht5D':
      _vm.getAppName() == 'dordrecht5D',
    'info-button-canals5D':
      _vm.getAppName() == 'canals5D'
  },on:{"click":function () { return _vm.infoDrawer = !_vm.infoDrawer; }}},[_c('BaseIcon',{attrs:{"icon":"info","size":"35px"}})],1),_c('ArticleDrawer'),_c('InfoDrawer',{directives:[{name:"show",rawName:"v-show",value:(_vm.isViewerLoaded),expression:"isViewerLoaded"}],attrs:{"hotspot":_vm.hotspot,"show":_vm.infoDrawer},on:{"onInfoDrawerClose":function () { return _vm.infoDrawer = !_vm.infoDrawer; }}}),_c('TimeLayerDrawer',{directives:[{name:"show",rawName:"v-show",value:(_vm.isViewerLoaded),expression:"isViewerLoaded"}],on:{"on5DMode":_vm.select5DMode,"onExpertMode":_vm.selectExpertMode,"onTimelayerChange":_vm.selectTimeLayer}}),(_vm.isSceneLoading)?_c('div',{attrs:{"id":"loader"}},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t("panorama.loading")))])])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }